import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {postMessage, rateSession} from "../../slice/chat.slice";
import {RatingIconDown, RatingIconUp} from "./icons";

export default function Rating() {
    const dispatch = useDispatch();
    const showRating = useSelector((state) => state.chat.showRating);

    if (!showRating) {
        return null;
    }

    const onRateDown = () => {
        dispatch(postMessage({ message: '👎' }));
        dispatch(rateSession(-1));
    };

    return (
        <div className="sb-rating">
            <button className="sb-rating--btn sb-rating--btn-up" type="button" onClick={() => dispatch(postMessage({ message: '👍' }))}><RatingIconUp /></button>
            <button className="sb-rating--btn sb-rating--btn-down" type="button" onClick={onRateDown}><RatingIconDown /></button>
        </div>
    );
}
